import { render, staticRenderFns } from "./custom-filter.vue?vue&type=template&id=1a12bce5&lang=pug"
import script from "./custom-filter.vue?vue&type=script&lang=js"
export * from "./custom-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports